export default {
    message: 'The {_field_} can be nullable',
    validate(value) {
        return true;
    }
}
